import Header from '@/components/UI/Header';
import { Panel, Tab, Tabs } from '@/components/UI/Tabs';
import type { State } from '@/model/State.model';
import { featuresSelector } from '@/support/Selectors';
import { useSelector } from 'react-redux';
import UpdatePassword from './UpdatePassword';
import UpdateAccount from './UpdateAccount';
import ConnectedAccount from '@/components/Account/BenchlingAuth/ConnectedAccount';

const Account = () => {
  const sso_enabled = useSelector(({ team: { team } }: State) => team?.sso_enabled ?? false);
  // Gated here rather than inside the component so that no request is made at all. The status,
  // start and unlink endpoints all require this flag, so rendering it for a team without the
  // feature would fetch the status, take a 403, and show every user an error toast plus a Sentry
  // event on every visit to this page.
  const benchlingDelegatedAuthEnabled = useSelector(
    (state: State) => featuresSelector(state)?.benchling_delegated_auth ?? false
  );

  return (
    <div className="ph4 pb3">
      <Header mainHeaderText="Account" />
      <div className="mv3 ui-card mw7">
        <Tabs>
          <div className="pt3 ph4 bb b--moon-gray">
            <Tab className="f4">Profile</Tab>
            {!sso_enabled && <Tab className="f4">Password</Tab>}
          </div>
          <div>
            <Panel>
              <UpdateAccount />
            </Panel>
            {!sso_enabled && (
              <Panel>
                <UpdatePassword />
              </Panel>
            )}
          </div>
        </Tabs>
      </div>
      {benchlingDelegatedAuthEnabled && <ConnectedAccount />}
    </div>
  );
};

export default Account;
